import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { filter, withLatestFrom } from 'rxjs/operators';

import {
  LoadCpCsas,
  LoadCpCsasSuccess,
  LoadMcCsas,
  LoadMcCsasSuccess,
  LoadMccsSuccess,
  LoadRfccsSuccess,
  LoadRfocSuccess,
  ResetActionTypes,
  SiteLoad,
} from '@completion/actions';
import { State } from '@completion/reducers';
import { getCurrentCpId, getCurrentProject } from '@completion/selectors';
import { ResetService } from '@completion/services';
import { NotificationService } from '../../services/notification.service';
import { trackResource } from './resource-fetch.util';

@Injectable()
export class ResetEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly resetService: ResetService,
    private readonly store: Store<State>,
    private readonly toastr: NotificationService,
  ) {}

  loadResetRfocs$ = createEffect(() =>
    this.actions$.pipe(
      ofType<SiteLoad>(ResetActionTypes.LoadRfocs),
      withLatestFrom(this.store.select(getCurrentProject), this.store.select(getCurrentCpId)),
      filter(([_, currentProject, currentCpId]) => !!(currentProject && currentCpId)),
      trackResource({
        actions$: this.actions$,
        store: this.store,
        toastr: this.toastr,
        service: this.resetService,
        method: 'getResetRfocs',
        serviceArgs: ([_, currentProject, currentCpId]) => [currentProject.id, currentCpId],
        onSuccess: (response) => new LoadRfocSuccess(response as any),
      }),
    ),
  );

  loadResetRfccs$ = createEffect(() =>
    this.actions$.pipe(
      ofType<SiteLoad>(ResetActionTypes.LoadRfccs),
      withLatestFrom(this.store.select(getCurrentProject), this.store.select(getCurrentCpId)),
      filter(([_, currentProject, currentCpId]) => !!(currentProject && currentCpId)),
      trackResource({
        actions$: this.actions$,
        store: this.store,
        toastr: this.toastr,
        service: this.resetService,
        method: 'getResetRfccs',
        serviceArgs: ([_, currentProject, currentCpId]) => [currentProject.id, currentCpId],
        onSuccess: (response) => new LoadRfccsSuccess(response as any),
      }),
    ),
  );

  loadResetMccs$ = createEffect(() =>
    this.actions$.pipe(
      ofType<SiteLoad>(ResetActionTypes.LoadMccs),
      withLatestFrom(this.store.select(getCurrentProject), this.store.select(getCurrentCpId)),
      filter(([_, currentProject, currentCpId]) => !!(currentProject && currentCpId)),
      trackResource({
        actions$: this.actions$,
        store: this.store,
        toastr: this.toastr,
        service: this.resetService,
        method: 'getResetMccs',
        serviceArgs: ([_, currentProject, currentCpId]) => [currentProject.id, currentCpId],
        onSuccess: (response) => new LoadMccsSuccess(response as any),
      }),
    ),
  );

  loadResetCpCsas$ = createEffect(() =>
    this.actions$.pipe(
      ofType<LoadCpCsas>(ResetActionTypes.LoadCpCsas),
      withLatestFrom(this.store.select(getCurrentProject), this.store.select(getCurrentCpId)),
      filter(([_, currentProject, currentCpId]) => !!(currentProject && currentCpId)),
      trackResource({
        actions$: this.actions$,
        store: this.store,
        toastr: this.toastr,
        service: this.resetService,
        method: 'getResetCpCsas',
        serviceArgs: ([_, currentProject, currentCpId]) => [currentProject.id, currentCpId],
        onSuccess: (response) => new LoadCpCsasSuccess(response as any),
      }),
    ),
  );

  loadResetMcCsas$ = createEffect(() =>
    this.actions$.pipe(
      ofType<LoadMcCsas>(ResetActionTypes.LoadMcCsas),
      withLatestFrom(this.store.select(getCurrentProject), this.store.select(getCurrentCpId)),
      filter(([_, currentProject, currentCpId]) => !!(currentProject && currentCpId)),
      trackResource({
        actions$: this.actions$,
        store: this.store,
        toastr: this.toastr,
        service: this.resetService,
        method: 'getResetMcCsas',
        serviceArgs: ([_, currentProject, currentCpId]) => [currentProject.id, currentCpId],
        onSuccess: (response) => new LoadMcCsasSuccess(response as any),
      }),
    ),
  );
}
